import React, { useCallback } from 'react';

type DispatcherDropZoneProps = {
  enabled: boolean;
  onDrop: () => void;
  className?: string;
  children: React.ReactNode;
};

export const DispatcherDropZone: React.FC<DispatcherDropZoneProps> = ({ enabled, onDrop, className, children }) => {
  const allowDrop = useCallback(
    (event: React.DragEvent) => {
      if (!enabled) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
    },
    [enabled],
  );

  const handleDrop = useCallback(
    (event: React.DragEvent) => {
      if (!enabled) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      onDrop();
    },
    [enabled, onDrop],
  );

  return (
    <div className={className} onDragEnterCapture={allowDrop} onDragOverCapture={allowDrop} onDrop={handleDrop}>
      {children}
    </div>
  );
};
